import {
  isWorkflowActionId,
  isWorkflowStageId,
  type WorkflowActionId,
  type WorkflowStageId,
  type WorkflowStatsInput,
  type WorkflowStatsSuccess,
} from '@terros/common'
import { useTantalimQuery } from '../query'
import { type GetHookResponse } from '../hooks'
import { workflowStatsKey } from './keys'

type Input = Pick<WorkflowStatsInput, 'workflowId' | 'targetIds'>

type Result = {
  stageCounts: Map<WorkflowStageId, number>
  actionCounts: Map<WorkflowActionId, number>
}
export function useWorkflowStats(input: Input): GetHookResponse<Result> {
  return useTantalimQuery<WorkflowStatsInput, WorkflowStatsSuccess, Result>({
    url: '/workflow/stats',
    queryKey: workflowStatsKey(input),
    input,
    options: { refetchOnMount: 'always' },
    convertResponse: (responseData) => {
      const stageCounts = new Map<WorkflowStageId, number>()
      const actionCounts = new Map<WorkflowActionId, number>()
      for (const [id, count] of Object.entries(responseData.stats)) {
        if (isWorkflowStageId(id)) {
          stageCounts.set(id, count)
        } else if (isWorkflowActionId(id)) {
          actionCounts.set(id, count)
        }
      }
      return {
        stageCounts,
        actionCounts,
      }
    },
  })
}
